// 认证类
exports.login_url = "/auth/login";
exports.loginsso_url = "/auth/login_sso";
exports.changePassword_url = "/auth/change_password";
// 公司自定义title、logo
exports.company_info_url = "/company_info"; // get
// 限时提醒
exports.deadline_info_url = "/use_deadline_info"


// 导航页（大屏）
exports.navigation_power_total_url = "/navigation/power_total_overview";
exports.navigation_device_url = "/navigation/device_overview";
exports.navigation_classroom_url = "/navigation/classroom_overview";
exports.navigation_device_status_url = "/navigation/device_status_overview"; //get
exports.navigation_alarm_time_analysis_url = "/navigation/alarm_time_analysis_overview"; //get
exports.navigation_building_url = "/navigation/building_overview"; //get
exports.navigation_alarm_times_total_url = "/navigation/alarm_times_total_overview"; //get
exports.navigation_power_consume_url = "/navigation/power_consume_overview"; //get
exports.navigation_device_url = "/navigation/device_overview"; //get

// 批量
var info = "/control/batch/mod/";
exports.device_info_url = "/control/batch/device_info" //get
exports.device_overview_url = "/control/batch/device_overview" //get
// 可控
exports.light = info + "lights" //get post
exports.light3 = info + "light3s" //get post
exports.adjustable_light = info + "adjustable_lights" //get post
exports.ultraviolet_sterilizer = info + "ultraviolet_sterilizers" //get post
exports.air_sterilizer = info + "air_sterilizers" //get post
exports.light_sterilizer = info + "light_sterilizers" //get post
exports.voice_announcer = info + "voice_announcers" //get post
exports.window_curtain = info + "window_curtains" //get post
exports.projector = info + "projectors" //get post
exports.ops = info + "opss" //get post
exports.sound_reinforcement = info + "sound_reinforcements" //get post
exports.curtain = info + "curtains" //get post
exports.air_conditioner = info + "air_conditioners" //get post
exports.air_conditioner2 = info + "air_conditioner2s" //get post
exports.fan = info + "fans" //get post
exports.speed_changeable_fan = info + "speed_changeable_fans" //get post
exports.fresh_air_machine = info + "fresh_air_machines" //get post
exports.all_power = info + "all_powers" //get post
exports.wall_plug = info + "wall_plugs" //get post
exports.door = info + "doors" //get post
exports.door_sensor = info + "door_sensors" //get post
// 只查询
exports.electric = info + "electrics" //get
exports.fourinone_sensor = info + "fourinone_sensors" //get
exports.light_sensor = info + "light_sensors" //get
exports.hb01 = info + "hb01s" //get
exports.temperature = info + "temperatures" //get


// 导航栏
exports.getBuilds_url = "/control/builds"; // get
// common
exports.queryStatus_url = "/control/query_status"; //post
// 获取多个网关数据
exports.getGateways = "/control/gateways/"; // get // int:id  type=all/building/floor/gateway
// 获取单个网关数据
exports.getGateway = "/control/gateway_devices/"; // get // int:id
// 获取单个网关所有数据（附刷新动作）
exports.getGatewayStatus = "/control/gateway/status/"; // get // int:id
// 获取视频
exports.controlCamera_url = "/control/camera/"; // get // int:id

// 系统管理manage-administrator
// 结构

exports.manageBuildings_url = "/administrator/manage/buildings"; // get

exports.manageBuilds_url = "/administrator/manage/builds"; // get, delete

exports.manageBuilding_url = "/administrator/manage/building/"; //post, patch, delete / int:id
exports.manageFloors_url = "/administrator/manage/floors"; //post
exports.manageFloor_url = "/administrator/manage/floor/"; //delete,
exports.manageClassrooms_url = "/administrator/manage/classrooms"; //post, delete, patch
exports.manageClassroom_url = "/administrator/manage/classroom/"; //post, delete, patch
exports.manageGateway_url = "/administrator/manage/gateway/"; //post, delete /int:id

exports.manageCameras_url = "/administrator/manage/cameras"; //get, post
exports.manageCamera_url = "/administrator/manage/camera/"; //get, post

exports.managePowerTotal_url = "/administrator/manage/power_total"; //get, patch

// 用户
exports.manageUsers_url = "/administrator/manage/users"; // get
exports.manageUser_url = "/administrator/manage/user/"; // post, patch, delete /int:id
exports.manageUserSync_url = "/administrator/manage/user_sync"; // post

// 设备组管理
exports.manageDeviceGroups_url = "/administrator/manage/device_groups"; // get
exports.manageDeviceGroup_url = "/administrator/manage/device_group/"; // get
exports.manageDeviceGroupRelateClassroom_url =
    "/administrator/manage/device_group_relate_classroom"; // post
// 告警配置
exports.manageAlarmShortMsgConfig_url =
    "/administrator/manage/alarm/server/short_msg";
exports.manageAlarmEmailConfig_url = "/administrator/manage/alarm/server/email";
exports.manageAlarmEventElectricityWarn_url =
    "/administrator/manage/alarm/event/electricity_warn";
exports.manageAlarmEventElectricityWarnManage_url =
    "/administrator/manage/alarm/event/electricity_warn_manage";
exports.manageAlarmEventElectricityWarnManageProtectAction_url =
    "/administrator/manage/alarm/event/electricity_warn_manage/protect_action/";

// 场景管理
exports.manageScenes_url = "/administrator/manage/scenes";
exports.manageScene_url = "/administrator/manage/scene/";
exports.manageDeviceGroupInfo_url = "/administrator/manage/device_group_info/";

// lora管理
exports.loraBuilding_url = "/administrator/lora/building/";
exports.loraBuilds_url = "/administrator/lora/builds";
exports.loraFloor_url = "/administrator/lora/floor/";
exports.loraClassroom_url = "/administrator/lora/classroom/";
exports.loraGateway_url = "/administrator/lora/gateway/";
exports.loraGatewayStatus = "/administrator/lora/gateway/status/";

// 日志
// 用户日志
exports.userLogs_url = "/log/user_logs"; //get
// 设备日志
exports.deviceLogs_url = "/log/device_logs"; //get
// 任务日志
exports.taskLogs_url = "/log/task_logs"; //get
// 告警日志
exports.warnLogs_url = "/log/warn_logs"; //get
// 管理日志
exports.manageLog_url = "/log/manage"; // get delete
exports.downloadLog_url = process.env.BASE_API + "/log/download/"; //get /filename

// 任务
// 任务管理
exports.task_group_info_url = "/task/device_group_info/"; // get
exports.task_device_groups_url = "/task/device_groups" // get

exports.tasks_url = "/task/tasks"; //get
exports.task_url = "/task/task/"; // get, post int:id

// 温度联动策略
exports.temperature_strategys_url = "/task/temperature_strategys"; //get
exports.temperature_strategy_url = "/task/temperature_strategy/"; // get, post int:id
// 人体联动策略
exports.hb01_strategys_url = "/task/hb01_strategys";
exports.hb01_strategy_url = "/task/hb01_strategy/";
// 门禁联动策略
exports.door_strategys_url = "/task/door_strategys"; // get
exports.door_strategy_url = "/task/door_strategy/"; // post、delete、patch
// 四合一联动策略
exports.fourinone_sensor_strategys_url = "/task/fourinone_sensor_strategys"; // get
exports.fourinone_sensor_strategy_url = "/task/fourinone_sensor_strategy/"; // put、post、delete、patch
// 光照联动策略
exports.light_sensor_strategys_url = "/task/light_sensor_strategys"; // get
exports.light_sensor_strategy_url = "/task/light_sensor_strategy/"; // put、post、delete、patch
// 恒照度联动策略
exports.fixed_brightness_strategys_url = "/task/fixed_brightness_strategys"; // get
exports.fixed_brightness_strategy_url = "/task/fixed_brightness_strategy/"; // put、post、delete、patch
exports.fixed_brightness_strategy_logs_url = "/task/fixed_brightness_strategy_logs/"; // put、post、delete、patch


// 控制模块请求, post请求, int:模块id
var prefix = "/control/mod/";
exports.temperature_url = prefix + "temperature/";
exports.hb01_url = prefix + "hb01/";
exports.all_power_url = prefix + "all_power/";
exports.other_power_url = prefix + "other_power/";
exports.light_url = prefix + "light/";
exports.light3_url = prefix + "light3/";
exports.adjustable_light_url = prefix + "adjustable_light/";
exports.window_curtain_url = prefix + "window_curtain/";
exports.curtain_url = prefix + "curtain/";
exports.ops_url = prefix + "ops/";
exports.projector_url = prefix + "projector/";
exports.sound_reinforcement_url = prefix + "sound_reinforcement/";
exports.fan_url = prefix + "fan/";
exports.airConditioner_url = prefix + "air_conditioner/";
exports.airConditioner2_url = prefix + "air_conditioner2/";
exports.electric_url = prefix + "electric/";
exports.pke_url = prefix + "door/";
exports.door_sensor_url = prefix + "door_sensor/";
exports.fourinone_sensor_url = prefix + "fourinone_sensor/";
exports.wall_plug_url = prefix + "wall_plug/";
exports.speed_changeable_fan_url = prefix + "speed_changeable_fan/";
exports.fresh_air_machine_url = prefix + "fresh_air_machine/";
exports.light_sensor_url = prefix + "light_sensor/";
exports.ultraviolet_sterilizer_url = prefix + "ultraviolet_sterilizer/";
exports.air_sterilizer_url = prefix + "air_sterilizer/";
exports.voice_announcer_url = prefix + "voice_announcer/";
exports.light_sterilizer_url = prefix + "light_sterilizer/";
exports.matrix44_url = prefix + "matrix44/";
exports.scene_url = "/control/scene/";


// 数据报表
var prefix = "/chart/";
exports.use_counts_url = prefix + "use_counts";
exports.power_total_url = prefix + "power_total";
exports.classroom_power_total_url = prefix + "classroom_power_total/";
exports.alarm_times_total_url = prefix + "alarm_times_total";
exports.alarm_time_analysis_url = prefix + "alarm_time_analysis";
exports.power_total_origin_records_url = prefix + "power_total_origin_records";
exports.power_error_origin_records_url = prefix + "power_error_origin_records";
exports.alarm_times_origin_records_url = prefix + "alarm_times_origin_records";
exports.power_consume_url = prefix + "power_consume";
exports.body_hour_freq_url = prefix + "lora/body_hour_freq";
exports.hb01_analysis_url = prefix + "hb01_analysis";
exports.light_sterilizer_analysis_url = prefix + "light_sterilizer_analysis";
// 月度能耗统计的楼宇楼层教室数据
exports.monthly_electric_structure = prefix + "structure";
exports.monthly_power_total_url = prefix + "power_total_records";



// WEBPACK FOOTER //
// ./src/api.js